import React, {useState} from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import ContactForm from '../ContactForm';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {useEditContactContext} from '../EditContactContext';

export default function PopupEditContact() {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {formik, editContact, getData} = useEditContactContext();

  return (
    <div>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        title={TTS.EDIT_CONTACT}
        onClick={() => {
          handleShowModal();
          getData();
        }}
        disabled={!can(T.FULL, S.CONTACTS_PAGE)}
        label={<img src={toAbsoluteUrl('media/common/Edit_primary.svg')} alt="edit"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal}>
        <ContactForm
          onSubmit={editContact}
          handleCloseModal={handleCloseModal}
          {...formik}
        />
      </ModalContainer>
    </div>
  );
}
